
import * as t from '@root/src/store/chisai/GCB2/actionTypes'
import { Project } from '../../../../types/main'
import { Audience, ActivationToEdit } from '../../../../types/GCB2'
import Vue, { Component, PropType } from 'vue'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import isNil from 'lodash/isNil'
import isPlainObject from 'lodash/isPlainObject'
import isString from 'lodash/isString'
import throttle from 'lodash/throttle'
import toNumber from 'lodash/toNumber'
import uniq from 'lodash/uniq'
import { ACTIVATION_DESCRIPTION_MAX_LENGTH, ACTIVATION_NAME_MAX_LENGTH, AUDEINCE_ADDITIONAL_SETTINGS } from '../../../../vars/GCB2'
import TextField from '../../../inputs/TextField.vue'
import MassEditAudienceTitleWithParams from './MassEditAudienceTitleWithParams.vue'
import { getActivationList, getAudience, getBotChannelList, getClientList, getClientYcCategoryList, getProductWithoutAbonementList, getServiceByCategoryList, getServiceCategoryList, getStaffList, getTagSubgroupList } from '../../../../api/chisai/GCB2'
import SpinnerLoader from '../../../../components/SpinnerLoader.vue'
import MassEditAutomailSettings from './MassEditAutomailSettings.vue'
import MassEditTimeLimitsSettings from './MassEditTimeLimitsSettings.vue'
import AudienceModal from '../changeActivation/AudienceSettings/AudienceModal.vue'
import AutomailModal from '../changeActivation/AudienceSettings/AutomailModal.vue'
import MessageModal from '../changeActivation/AudienceSettings/MessageModal.vue'
import { checkModuleIsActive } from '../../../../helpers/roles'
import TagInput from '@root/src/components/inputs/TagInput.vue'
import MassEditBotSettings from './MassEditBotSettings.vue'
import { MESSAGING_CONNECTOR_TYPES, CONNECTOR_TYPES, CHANNEL_TYPES } from '@root/src/vars/general'
import cfg from '@root/config'
import api from '@root/src/api/api'
import { getCascadesByProject } from '@/api/networkFixer'
import MassEditMessageVariablesSettings from './MassEditMessageVariablesSettings.vue'
import { MESSAGE_VARS } from '@/vars/GCB2'
import { v4 as uuidv4 } from 'uuid'
import { normalizeBotChannelList } from '../utils/botChannelList'

const FETCH_LIST_FUNCTIONS: any = {
    staff_list: getStaffList,
    service_list: getServiceByCategoryList,
    category_list: getServiceCategoryList,
    activation_list: getActivationList,
    tag_list: getTagSubgroupList,
    bot_channel_list: getBotChannelList,
    product_list: getProductWithoutAbonementList,
}

export default Vue.extend({
    name: 'ActivationsEditTable',
    components: {TextField, MassEditAudienceTitleWithParams, SpinnerLoader, MassEditAutomailSettings, MassEditTimeLimitsSettings, AudienceModal, AutomailModal, MessageModal, TagInput, MassEditBotSettings, MassEditMessageVariablesSettings},
    props: {
        activations: {required: true, type: Array as PropType<ActivationToEdit[]>},
        automailValidate: {required: true, type: Object as PropType<any>},
        isValidScripts: {required: true, type: Object as PropType<any>},
        filteredActivationsIds: {required: true, type: Array as PropType<number[]>},
        status: {required: true, type: String as PropType<'active' | 'inactive'>},
        tagList: {required: true, type: Array as PropType<string[]>},
        activationAvailable: {required: true, type: Number as PropType<number>, default: 0},
        // объект формата { deleted, updated } для массового сохранения переменных
        messageVars: {required: true, type: Object as PropType<any>, default: () => ({})},
    },

    data: () => ({
        loading: false,
        nameRules: [
            (v: any) => !!v || 'Обязательно',
            (v: any) =>
                v?.length <= ACTIVATION_NAME_MAX_LENGTH || `Меньше ${ACTIVATION_NAME_MAX_LENGTH} символов`,
        ],
        descritipionRules: [
            (v: any) =>
                v?.length <= ACTIVATION_DESCRIPTION_MAX_LENGTH ||
                `Меньше ${ACTIVATION_DESCRIPTION_MAX_LENGTH} символов`,
        ],
        audienceList: [],
        audienceFilterValues: {},
        lists: {} as any,
        priorityBackup: {},
        priorityInitial: {},
        priorityOld: {},
        audienceModalIsOpen: false,
        automailModalIsOpen: false,
        messageModalIsOpen: false,
        currentAudienceModal: null,
        currentAutomailModal: null,
        currentMessageModal: null,
        currentActivationId: null,
        audienceModalKey: 1,
        tableKey: 1,
        availableBots: [{ id: 'default', name: 'Не определено' }] as any,
        cascadesForBotSettings: [] as any[],
        disableCardVirtualization: false,
        visibleActivationIds: [] as number[],
        currentScrollDirection: 'idle' as 'idle' | 'down' | 'up',
        lastScrollY: 0,
        rowHeightsById: {} as Record<number, number>,
        averageRowHeight: 820,
        searchTextCacheById: {} as Record<number, string>,
        lastBrowserFindText: '',
        lastBrowserFindRequestedAt: 0,
        lastFilteredIdsHash: '',
        isUpdatingVisibility: false,
        messageVarClientList: [] as any[],
        messageVarExceptions: [] as any[],
    }),
    setup: () => {
        return {}
    },
    watch: {
        audienceModalIsOpen: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.currentAudienceModal = null
                    this.audienceModalKey ++
                }
            }
        },
        filteredActivationsIds: {
            immediate: true,
            handler(val) {
                const nextHash = Array.isArray(val) ? val.join(',') : ''
                const hasRealChange = nextHash !== this.lastFilteredIdsHash
                this.lastFilteredIdsHash = nextHash
                if (!hasRealChange) return
                this.tableKey++
                this.visibleActivationIds = this.filteredActivations.slice(0, 5).map((activation) => activation.id)
                this.$nextTick(() => {
                    if (this.filteredActivations.length) {
                        this.setVisibleAroundActivations([this.filteredActivations[0].id], 'down')
                    }
                })
            }
        },
        filteredActivations: {
            handler(newVal, oldVal) {
                if (!this.disableCardVirtualization && oldVal && Array.isArray(oldVal) && Array.isArray(newVal)) {
                    const oldIds = oldVal.map(a => a.id).join(',')
                    const newIds = newVal.map(a => a.id).join(',')
                    const oldOrder = oldVal.map(a => ({ id: a.id, priority: a.priority })).slice(0, 5)
                    const newOrder = newVal.map(a => ({ id: a.id, priority: a.priority })).slice(0, 5)
                    const orderChanged = oldIds !== newIds
                    const sameIdsButDifferentOrder = oldIds === newIds && JSON.stringify(oldOrder) !== JSON.stringify(newOrder)
                    if (orderChanged || sameIdsButDifferentOrder) {
                        this.updateVirtualizationAfterSort()
                    }
                }
            },
            deep: false
        },
        automailModalIsOpen: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.currentActivationId = null
                }
            }
        }, 
        messageModalIsOpen: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.currentActivationId = null
                    this.currentMessageModal = null
                    const nevValidate = this.activations.reduce((acc, el) => {
                        const messageParts = el?.message?.messageParts?.filter(i => !i._deleted)
                        const isValidScript = messageParts.every(i => i?.textVariant?.trim()?.length > 2)
                        const isEmpty = messageParts.filter(i => !i._deleted).length < 1
                        acc[el.id] = {
                            isAutomail: this.automailValidate[el.id].isAutomail,
                            isValidScripts: isValidScript && !isEmpty,
                            isSaveButtonClicked: this.automailValidate[el.id].isSaveButtonClicked,
                        }
                        return acc
                    }, {})
                    this.$emit('set-validate', nevValidate)
                }
            }
        }
    },
    computed: {
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        isHrProject(): boolean {
            return this.project.connectors.find((con) => con.connectorType === CONNECTOR_TYPES.GCB2)?.hrProject || false
        },
        pseudoNetworkProjects(): Project[] {
            return this.$store.getters.pseudoNetworkProjects || []
        },
        currentPriority(): any {
            return this.activations.reduce((acc, el) => {
                acc[el.id] = el.priority
                return acc
            }, {})
        },
        priorityDiff(): boolean {
            return !isEqual(this.priorityInitial, this.currentPriority) && this.activations.length > 1
        },
        tagsIsActive(): Boolean {
            return checkModuleIsActive(this.project.id, 'gcb2:tasklist:activationTags')
        },
        currentActivation(): ActivationToEdit {
            return this.activations.find(el => el.id === this.currentActivationId)
        },
        filteredActivations(): ActivationToEdit[] {
            return this.activations.filter(el => this.filteredActivationsIds.includes(el.id))
        },
        activationIndexById(): Record<number, number> {
            return this.filteredActivations.reduce((acc, activation, index) => {
                acc[activation.id] = index
                return acc
            }, {} as Record<number, number>)
        },
        connectorsHashMapWithKeysByConnectorsType(){
            return this.$store.getters.connectorsHashMapWithKeysByConnectorsType
        },
        yClientsConnector() {
            return this.$store.getters
                .projectById(this.$router.currentRoute.params.id)
                .connectors.find((el) => el.connectorType === CONNECTOR_TYPES.yClients)
        },
        channelOptionsForBotSettings(): { label: string; value: string }[] {
            if (!this.project?.isChannelsRework || !Array.isArray(this.cascadesForBotSettings)) return []
            const channelTypes = Object.values(CHANNEL_TYPES)
            const chList = (this.project.connectors || []).filter((c: any) =>
                !c.isChisai && c.connectorType !== CONNECTOR_TYPES.whatsappBasis && channelTypes.includes(c.connectorType)
            )
            const getChannelIndex = (connectorType: string, connectorId: string) => {
                const sortedChannels = (this.project?.connectors || [])
                    .filter((c: any) => !c.isChisai && c.connectorType === connectorType)
                    .sort((a: any, b: any) => {
                        const aT = a.createdAt > 0 ? a.createdAt : Number.MAX_SAFE_INTEGER
                        const bT = b.createdAt > 0 ? b.createdAt : Number.MAX_SAFE_INTEGER
                        return aT === bT ? 0 : aT < bT ? -1 : 1
                    })
                const idx = sortedChannels.findIndex((c: any) => c.connectorId === connectorId)
                return idx >= 0 ? idx + 1 : 1
            }
            const getChannelDisplayName = (connectorType: string, index: number) => {
                const names: Record<string, string> = { [CHANNEL_TYPES.whatsappChannel]: 'WhatsApp', [CHANNEL_TYPES.telegramChannel]: 'Telegram', [CHANNEL_TYPES.maxChannel]: 'MAX' }
                const base = names[connectorType] || connectorType
                return index === 1 ? base : `${base} ${index}`
            }
            const getCustomCascadeNumber = (cascadeId: string | number) => {
                const customCascades = this.cascadesForBotSettings
                    .filter((c: any) => c && c.cascadeType === 'custom')
                    .sort((a: any, b: any) => {
                        const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : Number.MAX_SAFE_INTEGER
                        const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : Number.MAX_SAFE_INTEGER
                        const safeATime = Number.isNaN(aTime) ? Number.MAX_SAFE_INTEGER : aTime
                        const safeBTime = Number.isNaN(bTime) ? Number.MAX_SAFE_INTEGER : bTime
                        if (safeATime !== safeBTime) return safeATime - safeBTime
                        return String(a?.id ?? '').localeCompare(String(b?.id ?? ''))
                    })
                const customIndex = customCascades.findIndex((c: any) => String(c.id) === String(cascadeId))
                return customIndex >= 0 ? customIndex + 2 : null
            }
            const getCustomCascadeLabel = (cascade: any) => {
                const number = getCustomCascadeNumber(cascade?.id)
                const name = cascade?.name ? String(cascade.name).trim() : ''
                if (!number) return 'Каскад'
                return name ? `Каскад ${number} - ${name}` : `Каскад ${number}`
            }
            const gcb2 = (this.project?.connectors || []).find((el: any) => el.connectorType === CONNECTOR_TYPES.GCB2)
            const defChannel = get(gcb2, 'settings.defaultActivationSendChannel') ?? get(gcb2, 'defaultActivationSendChannel') ?? null
            let defaultLabel = 'По умолчанию'
            if (defChannel) {
                const def = (() => {
                    let v = defChannel
                    if (isString(v)) { try { v = JSON.parse(v) } catch { return null } }
                    if (!isPlainObject(v)) return null
                    const id = (v as any).id ?? (v as any).channelId ?? (v as any).connectorId
                    return isNil(id) ? null : { type: (v as any).type || null, id }
                })()
                if (def?.type === 'cascade') {
                    const found = this.cascadesForBotSettings.find((c: any) => c && String(c.id) === String(def.id))
                    defaultLabel = `По умолчанию (${found?.cascadeType === 'custom' ? getCustomCascadeLabel(found) : 'Каскад'})`
                } else if (def?.id) {
                    const conn = (this.project?.connectors || []).find((c: any) => String(c.channelId || c.connectorId) === String(def.id))
                    if (conn) {
                        const idx = getChannelIndex(conn.connectorType, conn.connectorId)
                        const dName = getChannelDisplayName(conn.connectorType, idx)
                        defaultLabel = `По умолчанию (${conn.phone ? `${dName} (${conn.phone})` : dName})`
                    }
                }
            }
            const options: { label: string; value: string }[] = [{ label: defaultLabel, value: 'default' }]
            chList.forEach((connector: any) => {
                const idx = getChannelIndex(connector.connectorType, connector.connectorId)
                const dName = getChannelDisplayName(connector.connectorType, idx)
                const label = connector.phone ? `${dName} (${connector.phone})` : dName
                options.push({ label, value: JSON.stringify({ type: 'channel', id: connector.channelId || connector.connectorId }) })
            })
            const cascadesForOptions = this.cascadesForBotSettings
                .filter((c: any) => c && (c.cascadeType === 'mailings' || c.cascadeType === 'custom'))
                .filter((c: any) => c.cascadeType !== 'custom' || (Array.isArray(c.channels) && c.channels.length > 0))
            const sortedCustomCascades = cascadesForOptions
                .filter((c: any) => c.cascadeType === 'custom')
                .sort((a: any, b: any) => {
                    const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : Number.MAX_SAFE_INTEGER
                    const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : Number.MAX_SAFE_INTEGER
                    const safeATime = Number.isNaN(aTime) ? Number.MAX_SAFE_INTEGER : aTime
                    const safeBTime = Number.isNaN(bTime) ? Number.MAX_SAFE_INTEGER : bTime
                    if (safeATime !== safeBTime) return safeATime - safeBTime
                    return String(a?.id ?? '').localeCompare(String(b?.id ?? ''))
                })
            const sortedCascadesForOptions = [
                ...cascadesForOptions.filter((c: any) => c.cascadeType !== 'custom'),
                ...sortedCustomCascades,
            ]
            sortedCascadesForOptions.forEach((c: any) => {
                const label = c.cascadeType === 'custom' ? getCustomCascadeLabel(c) : 'Каскад'
                options.push({ label, value: JSON.stringify({ type: 'cascade', id: c.id }) })
            })
            return options
        },
    },
    methods: {
        getRowOuterHeight(row: HTMLElement): number {
            if (!row) return 0
            const rectHeight = row.getBoundingClientRect().height || 0
            const styles = window.getComputedStyle(row)
            const marginTop = parseFloat(styles.marginTop || '0') || 0
            const marginBottom = parseFloat(styles.marginBottom || '0') || 0
            return rectHeight + marginTop + marginBottom
        },
        refreshVisibleRowHeights() {
            if (!this.$el) return
            const rows = Array.from(this.$el.querySelectorAll('.row-wrapper[data-activation-id]')) as HTMLElement[]
            if (!rows.length) return
            const measured: number[] = []
            rows.forEach((row) => {
                const id = Number(row.dataset.activationId)
                if (!Number.isFinite(id)) return
                const height = this.getRowOuterHeight(row)
                if (height > 0) {
                    this.$set(this.rowHeightsById, id, height)
                    measured.push(height)
                }
            })
            if (measured.length) {
                this.averageRowHeight =
                    Math.round((measured.reduce((sum, h) => sum + h, 0) / measured.length) * 100) / 100
            }
        },
        getActivationSearchText(activation: ActivationToEdit): string {
            const tags = Array.isArray(activation?.tags) ? activation.tags.join(' ') : ''
            const audience = activation?.audienceSettings?.name || ''
            const audienceId = activation?.audienceSettings?.id
            const desc = activation?.description || ''
            const name = activation?.name || ''
            const idText = activation?.id
                ? `активация ${activation.id} id ${activation.id} #${activation.id} номер ${activation.id}`
                : ''
            const audienceIdText = audienceId
                ? `audience__id #${audienceId} аудитория ${audienceId} id аудитории ${audienceId}`
                : ''
            const parts = (activation as any)?.message?.messageParts || []
            const scriptText = Array.isArray(parts)
                ? parts
                    .filter((p: any) => !p?._deleted)
                    .map((p: any) => p?.textVariant || '')
                    .join(' ')
                : ''
            return [idText, audienceIdText, name, desc, tags, audience, activation?.isRunning ? 'вкл' : 'выкл', scriptText]
                .filter(Boolean)
                .join(' ')
        },
        getAudienceConditionSearchText(activation: ActivationToEdit): string {
            const activationAny = activation as any
            const audienceId = activationAny?.audienceSettings?.id
            const audience = this.selectedAudience(audienceId)
            const audienceName = audience?.name || ''
            const audienceSchemaText = audience?.settings ? JSON.stringify(audience.settings) : ''
            const audienceFilterText = this.audienceFilterValues?.[activation.id]
                ? JSON.stringify(this.audienceFilterValues[activation.id])
                : ''
            const extraFilterText = activationAny?.extra?.filter ? JSON.stringify(activationAny.extra.filter) : ''
            return [audienceName, audienceSchemaText, audienceFilterText, extraFilterText].filter(Boolean).join(' ')
        },
        computeActivationDeepSearchText(activation: ActivationToEdit): string {
            const activationAny = activation as any
            const automailText = activationAny?.automailSettings?.extra?.automail
                ? JSON.stringify(activationAny.automailSettings.extra.automail)
                : ''
            const botText = activationAny?.extra?.sendingSettings
                ? JSON.stringify(activationAny.extra.sendingSettings)
                : activationAny?.extra?.preferedBot || ''
            const messageText = activationAny?.message?.messageParts
                ? JSON.stringify(activationAny.message.messageParts)
                : ''
            return [
                this.getActivationSearchText(activation),
                this.getAudienceConditionSearchText(activation),
                automailText,
                botText,
                messageText,
            ]
                .filter(Boolean)
                .join(' ')
        },
        getCachedActivationDeepSearchText(activation: ActivationToEdit): string {
            const id = Number(activation?.id)
            if (!Number.isFinite(id)) return this.computeActivationDeepSearchText(activation)
            if (!this.searchTextCacheById[id]) {
                this.$set(this.searchTextCacheById, id, this.computeActivationDeepSearchText(activation))
            }
            return this.searchTextCacheById[id]
        },
        captureBrowserFindText() {
            const selectedText = String(window.getSelection?.()?.toString?.() || '').trim()
            if (selectedText.length >= 2) this.lastBrowserFindText = selectedText
        },
        refreshBrowserFindHighlight() {
            const winWithFind = window as Window & {
                find?: (
                    text: string,
                    caseSensitive?: boolean,
                    backwards?: boolean,
                    wrapAround?: boolean,
                    wholeWord?: boolean,
                    searchInFrames?: boolean,
                    showDialog?: boolean
                ) => boolean
            }
            if (typeof winWithFind.find !== 'function') return
            const selectedText = String(window.getSelection?.()?.toString?.() || '').trim()
            const query = selectedText || this.lastBrowserFindText
            if (!query || query.length < 2) return
            this.lastBrowserFindText = query
            const isSearchRecent = Date.now() - this.lastBrowserFindRequestedAt < 2 * 60 * 1000
            if (!isSearchRecent) return
            winWithFind.find(query, false, false, true, false, false, false)
        },
        isActivationVisible(activationId: number): boolean {
            return this.visibleActivationIds.includes(activationId)
        },
        getActivationPlaceholderHeight(activationId: number): number {
            return Math.round(this.rowHeightsById[activationId] || this.averageRowHeight)
        },
        shouldRenderPlaceholderSearchText(): boolean {
            if (!this.lastBrowserFindText || this.lastBrowserFindText.length < 2) return false
            return Date.now() - this.lastBrowserFindRequestedAt < 2 * 60 * 1000
        },
        setVisibleAroundActivations(
            activationIds: number[],
            direction: 'idle' | 'down' | 'up' = 'idle'
        ) {
            if (!Array.isArray(activationIds) || !activationIds.length) return
            // Предотвращаем множественные одновременные обновления
            if (this.isUpdatingVisibility) {
                return
            }
            this.isUpdatingVisibility = true
            const nextVisibleIds = new Set<number>()
            activationIds.forEach((activationId) => {
                const centerIndex = this.activationIndexById[activationId]
                if (!Number.isFinite(centerIndex)) return
                const from = Math.max(0, centerIndex - 2)
                const to = Math.min(this.filteredActivations.length - 1, centerIndex + 2)
                for (let idx = from; idx <= to; idx += 1) {
                    const candidate = this.filteredActivations[idx]
                    if (candidate) nextVisibleIds.add(candidate.id)
                }
            })
            if (!nextVisibleIds.size && this.filteredActivations.length) {
                nextVisibleIds.add(this.filteredActivations[0].id)
            }
            const newVisibleIds = Array.from(nextVisibleIds)
            // Проверяем, действительно ли нужно обновлять видимость
            const currentIdsSet = new Set(this.visibleActivationIds)
            const newIdsSet = new Set(newVisibleIds)
            const hasChanges = newVisibleIds.length !== this.visibleActivationIds.length ||
                newVisibleIds.some(id => !currentIdsSet.has(id)) ||
                this.visibleActivationIds.some(id => !newIdsSet.has(id))
            if (!hasChanges) {
                this.isUpdatingVisibility = false
                return
            }
            this.visibleActivationIds = newVisibleIds
            this.$nextTick(() => {
                this.refreshVisibleRowHeights()
                this.refreshBrowserFindHighlight()
                this.isUpdatingVisibility = false
            })
        },
        shouldShiftVisibleWindow(candidateActivationId: number): boolean {
            if (!this.visibleActivationIds.length) return true
            // Если элемент уже видим, не нужно сдвигать окно
            if (this.visibleActivationIds.includes(candidateActivationId)) return false
            const candidateIndex = this.activationIndexById[candidateActivationId]
            if (!Number.isFinite(candidateIndex)) {
                return false
            }
            const visibleIndexes = this.visibleActivationIds
                .map((id) => this.activationIndexById[id])
                .filter((idx) => Number.isFinite(idx))
                .sort((a, b) => a - b)
            if (!visibleIndexes.length) return true
            const minVisibleIndex = visibleIndexes[0]
            const maxVisibleIndex = visibleIndexes[visibleIndexes.length - 1]
            const shouldShift = this.currentScrollDirection === 'down' 
                ? candidateIndex >= maxVisibleIndex - 1
                : this.currentScrollDirection === 'up'
                    ? candidateIndex <= minVisibleIndex + 2
                    : candidateIndex < minVisibleIndex || candidateIndex > maxVisibleIndex
            return shouldShift
        },
        syncVisibleActivationsByViewport: throttle(function (this: any) {
            if (!this.$el || !this.filteredActivations.length) return
            const currentScrollY = window.scrollY || window.pageYOffset || 0
            const delta = currentScrollY - this.lastScrollY
            this.currentScrollDirection = delta > 1 ? 'down' : delta < -1 ? 'up' : 'idle'
            this.lastScrollY = currentScrollY
            
            // Вычисляем индекс активации на основе скролла и высот элементов
            const viewportTop = currentScrollY
            const viewportBottom = currentScrollY + window.innerHeight
            const viewportCenter = viewportTop + window.innerHeight * 0.45
            
            // Вычисляем позицию каждого элемента на основе накопленных высот
            let accumulatedHeight = 0
            let candidateIndex = 0
            let minDistance = Number.POSITIVE_INFINITY
            
            for (let i = 0; i < this.filteredActivations.length; i++) {
                const activation = this.filteredActivations[i]
                const height = this.rowHeightsById[activation.id] || this.averageRowHeight
                const elementTop = accumulatedHeight
                const elementBottom = accumulatedHeight + height
                const elementCenter = accumulatedHeight + height / 2
                
                // Проверяем, находится ли элемент в области видимости
                if (elementTop <= viewportCenter && elementBottom >= viewportCenter) {
                    candidateIndex = i
                    break
                }
                
                // Ищем ближайший элемент к центру viewport
                const distance = Math.abs(elementCenter - viewportCenter)
                if (distance < minDistance) {
                    minDistance = distance
                    candidateIndex = i
                }
                
                accumulatedHeight = elementBottom
            }
            
            const candidateActivationId = this.filteredActivations[candidateIndex]?.id
            if (!candidateActivationId) return
            
            const shouldShift = this.shouldShiftVisibleWindow(candidateActivationId)
            if (shouldShift) {
                this.setVisibleAroundActivations([candidateActivationId], this.currentScrollDirection)
            }
        }, 80),
        onBrowserFindKeydown(event: KeyboardEvent) {
            const key = String(event.key || '').toLowerCase()
            const isFindShortcut = (event.ctrlKey || event.metaKey) && key === 'f'
            const isFindNext = key === 'f3'
            if (!isFindShortcut && !isFindNext) return
            this.lastBrowserFindRequestedAt = Date.now()
            this.captureBrowserFindText()
        },
        selectedAudience(id: number): Audience {
            if (!this.audienceList || !Array.isArray(this.audienceList)) return undefined
            return this.audienceList.find(el => el.id === id)
        },
        onPriorityInput(event, activation) {
            let val = event.target.value.replace(/[^0-9]/g, '')
            if (val.length > 1) val = val.replace(/^0+/, '')
            if (val === '') {
                event.target.value = ''
                return
            }
            this.$set(activation, 'priority', Number(val))
            event.target.value = val
        },
        onPriorityFocus(event, activation) {
            this.$set(this.priorityBackup, activation.id, activation.priority)
            // Lazy init: if priorityOld wasn't populated (race at mount time), initialize now
            if (isEmpty(this.priorityOld)) {
                this.priorityOld = cloneDeep(this.currentPriority)
                this.priorityInitial = cloneDeep(this.currentPriority)
            }
        },
        onPriorityBlur(event, activation) {
            let val = event.target.value
            if (val === '' || val === '0') {
                activation.priority = this.priorityBackup[activation.id] || 1
                this.$set(activation, 'priority', this.priorityBackup[activation.id] || 1)
                event.target.value = activation.priority
            } else {
                const maxPriority = this.activations.filter(el => el.isRunning).length
                if (Number(val) > maxPriority) {
                    activation.priority = maxPriority
                    this.$set(activation, 'priority', maxPriority)
                    event.target.value = String(maxPriority)
                }
            }
            this.swapPriority()
            this.$nextTick(() => {
                if (!this.disableCardVirtualization) {
                    this.updateVirtualizationAfterSort()
                }
            })
        },
        onlyNumberInput(e) {
            if (!((e.key >= '0' && e.key <= '9') || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(e.key))) {
                e.preventDefault();
            }
        },
        collectSchemaItems(items: any[], acc: any[] = []): any[] {
            (items || []).forEach((item) => {
                if (!item) {
                    return
                }
                if (Array.isArray(item)) {
                    this.collectSchemaItems(item, acc)
                    return
                }
                acc.push(item)
                if (Array.isArray(item.block_schema)) {
                    this.collectSchemaItems(item.block_schema, acc)
                }
                if (Array.isArray(item.content)) {
                    this.collectSchemaItems(item.content, acc)
                }
            })
            return acc
        },
        initAudienceFilterValues() {
            for (let i in this.activations) {
                const audience = this.audienceList.find((el: Audience) => el.id === this.activations[i].audienceSettings?.id)
                    let filterValue = {} as any
                    let filterValueShort = {} as any
                    const schema = audience?.settings.schema
                    const shortSchema = audience?.settings.shortSchema
                    const additionalParamsList = audience?.settings.additional_params_list
                    const applyDefaultsFromItem = (schemaItem: any) => {
                        if (!schemaItem) {
                            return
                        }
                        if (Array.isArray(schemaItem)) {
                            schemaItem.forEach(applyDefaultsFromItem)
                            return
                        }
                        if (schemaItem.valueField) {
                            let def = schemaItem.defaultValue
                            if (def === undefined && schemaItem.multiple) {
                                def = []
                            }
                            const value =
                                this.activations[i].audienceSettings?.id === audience?.id
                                    ? this.activations[i].extra?.filter?.[schemaItem.valueField] ?? def
                                    : def
                            filterValue[schemaItem.valueField] = value
                        }
                        if (Array.isArray(schemaItem.block_schema)) {
                            schemaItem.block_schema.forEach(applyDefaultsFromItem)
                        }
                        if (Array.isArray(schemaItem.content)) {
                            schemaItem.content.forEach(applyDefaultsFromItem)
                        }
                    }
                    if (schema) {
                        schema.flat().forEach(applyDefaultsFromItem)
                    }
                    if (additionalParamsList) {
                        additionalParamsList.forEach((param: string) => {
                            const paramSchema = get(AUDEINCE_ADDITIONAL_SETTINGS, `${param}.schema`)
                            if (Array.isArray(paramSchema)) {
                                const paramSchemaRows = paramSchema as any[]
                                paramSchemaRows.flat().forEach(applyDefaultsFromItem)
                            }
                            const defautValue = get(AUDEINCE_ADDITIONAL_SETTINGS, `${param}.defaultValue`)
                            filterValue[param] =
                            this.activations[i].audienceSettings?.id === audience?.id
                                    ? this.activations[i].extra?.filter?.[param] ?? defautValue
                                    : defautValue
                        })
                    }
                    if (this.activations[i].audienceSettings?.id === audience?.id) {
                        filterValue = Object.assign(filterValue, this.activations[i].extra?.filter)
                    }
                    this.audienceFilterValues[this.activations[i].id] = {}
                    this.audienceFilterValues[this.activations[i].id][audience?.id] = filterValue
                    const shortSchemaWithValueKeys = shortSchema?.filter(el => el.valueField)?.map(el => el.valueField)
                    const filteredKeys = Object.keys(filterValue)?.filter(el => shortSchemaWithValueKeys?.includes(el))
                    filterValueShort = Object.fromEntries(
                        filteredKeys
                            .filter(key => key in filterValue)
                            .map(key => [key, filterValue[key]])
                    );
            }
        },
        async fetchLists() {
            const listsToFetch = uniq(
                this.audienceList
                    .flatMap(el => this.collectSchemaItems([
                        ...(el.settings.schema?.flat() || []),
                        ...(el.settings.shortSchema?.flat() || []),
                    ]))
                    .map(el => (el?.type === 'select' ? el.list : null))
                    .filter(el => el)
            )
            await Promise.all(
                listsToFetch.map(async (el: any) => {
                    const fetch = FETCH_LIST_FUNCTIONS[el]
                    if (fetch) {
                        const list = await fetch({ projectId: this.project.id }).then((el: any) => el.data)
                        this.lists[el] =
                            el === 'bot_channel_list'
                                ? normalizeBotChannelList(list, this.project.connectors)
                                : list
                    }
                })
            )
            if(this.yClientsConnector) {
                this.lists['client_category_list'] = await getClientYcCategoryList({ projectId: this.project.id }).then((el: any) => el.data)
            }
            if(this.isHrProject) {
                this.lists['filial_list'] = this.pseudoNetworkProjects?.filter(el => !el.isMain)
                this.lists['specialization_list'] = ['X9FUHP3L5', 'XSTM8F6WE'].includes(this.project.id) ? [
                    {name: 'Ногтевой мастер', id: 'Ногтевой мастер'},
                    {name: 'Бровист/лашмейкер', id: 'Бровист/лашмейкер'},
                    {name: 'Массажист', id: 'Массажист'},
                    {name: 'Визажист-стилист/Парикмахер', id: 'Визажист-стилист/Парикмахер'},
                    {name: 'Мастер эпиляции', id: 'Мастер эпиляции'},
                    {name: 'Администратор', id: 'Администратор'},
                    {name: 'Управляющий', id: 'Управляющий'},
                    {name: 'Собственник', id: 'Собственник'},
                ] : [
                    {name: 'Администратор', id: 'Администратор'},
                    {name: 'Косметолог', id: 'Косметолог'},
                    {name: 'Мастер маникюра', id: 'Мастер маникюра'},
                    {name: 'Парикмахер', id: 'Парикмахер'},
                    {name: 'Другое', id: 'Другое'},
                ]
            }
        },
        saveInParent() {
            if (!this.loading) {
                for (let i in this.activations) {
                    let filter = this.activations[i]?.extra?.filter
                    const audienceId = this.activations[i]?.audienceSettings?.id
                    const activationId = this.activations[i]?.id
                    const isEmptyDefault = isEmpty(this.audienceFilterValues[activationId][audienceId])
                    if (isEmptyDefault) {
                        continue
                    }else if (!filter || isEmpty(filter)) {
                        filter = this.audienceFilterValues[activationId][audienceId]
                        this.$emit('edit-filter', activationId, filter)
                    }else if (filter) {
                        this.audienceFilterValues[activationId][audienceId] = Object.assign(
                            {},
                            this.audienceFilterValues[activationId][audienceId],
                            filter
                        )
                        filter = this.audienceFilterValues[activationId][audienceId]
                        this.$emit('edit-filter', activationId, filter)
                    }             
                }
            } 
        },
        swapPriority() {
            const oldPriority = cloneDeep(this.priorityOld)
            const newPriority = cloneDeep(this.currentPriority)
            const result = oldPriority
            const changed = Object.keys(newPriority).find(id => oldPriority[id] !== newPriority[id])
            if (!changed) return
            const from = oldPriority[changed]
            const to = newPriority[changed]
            if (from === to) return
            if (to > from) {
                Object.keys(result).forEach((id) => {
                    if (id !== changed && result[id] > from && result[id] <= to) {
                        result[id] = result[id] - 1
                    }
                })
            } else {
                Object.keys(result).forEach((id) => {
                    if (id !== changed && result[id] >= to && result[id] < from) {
                        result[id] = result[id] + 1
                    }
                })
            }
            result[changed] = to
            const runningActivations = this.activations.filter(i => i.isRunning)
            const activationsIds = runningActivations.map(i => i.id)
            Object.keys(this.priorityOld).forEach(el => {
                if (activationsIds.includes(Number(el))) {
                    this.priorityOld[el] = result[el]
                } else {
                    this.priorityOld[el] = null
                }
            })
            Object.keys(this.priorityOld).forEach(el => {
                const activation = runningActivations.find(i => i.id === toNumber(el))
                if (!activation) return
                activation.priority = this.priorityOld[el]
            })
            this.normalizeEnabledPriorities()
            this.$nextTick(() => {
                if (!this.disableCardVirtualization) {
                    this.updateVirtualizationAfterSort()
                }
            })
        },
        sortByPriority() {
            this.$emit('sort')
            this.priorityInitial = cloneDeep(this.currentPriority)
            this.tableKey++
            this.$nextTick(() => {
                this.updateVirtualizationAfterSort()
            })
        },
        updateVirtualizationAfterSort() {
            if (!this.disableCardVirtualization) {
                // Сбрасываем флаг перед обновлением
                this.isUpdatingVisibility = false
                // Двойной $nextTick: первый ждет обновления DOM, второй - пересчета computed
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        if (!this.filteredActivations.length) return
                        const firstActivationId = this.filteredActivations[0].id
                        if (!Number.isFinite(this.activationIndexById[firstActivationId])) {
                            return
                        }
                        // Не устанавливаем visibleActivationIds напрямую, пусть setVisibleAroundActivations это сделает
                        this.setVisibleAroundActivations([firstActivationId], 'down')
                    })
                })
            }
        },
        openAudienceModal(audienceId: number, activationId) {
            this.currentActivationId = activationId
            this.currentAudienceModal = this.selectedAudience(audienceId)
            this.audienceModalIsOpen = true
        },
        openAutomailModal(id: number) {
            const activation = this.activations.find(el => el.id === id)
            this.currentAutomailModal = activation.automailSettings
            this.currentActivationId = id
            this.automailModalIsOpen = true
        },
        openMessageModal(id: number) {
            const activation = this.activations.find(el => el.id === id)
            this.currentMessageModal = activation
            this.currentActivationId = id
            this.messageModalIsOpen = true
        },
        setAudienceFilterValues(id: number, value: any) {
            this.audienceFilterValues[id] = value
            if (this.searchTextCacheById[id]) this.$delete(this.searchTextCacheById, id)
        },
        setAutomailSettings(id: number, value: any) {
            const activation = this.activations.find(el => el.id === id)
            activation.automailSettings = value
            if (this.searchTextCacheById[id]) this.$delete(this.searchTextCacheById, id)
        },
        setMessageSettings(id: number, value: any) {
            const activation = this.activations.find(el => el.id === id)
            activation.message.messageParts = value
            activation.message.messageParts = [...activation.message.messageParts]
            if (this.searchTextCacheById[id]) this.$delete(this.searchTextCacheById, id)
        },
        tableKeyIncrease() {
            this.tableKey++
        },
        onMessageVarExceptionsChange(updatedExceptions) {
            this.messageVarExceptions = updatedExceptions
        },
        onActivationRowUpdate(id, updatedActivation) {
            const index = this.activations.findIndex(a => a.id === id)
            if (index !== -1) {
                this.$set(this.activations, index, updatedActivation)
            }
            if (this.searchTextCacheById[id]) this.$delete(this.searchTextCacheById, id)
        },
        async initData() {
            this.loading = true
            this.priorityInitial = cloneDeep(this.currentPriority)
            try {
            // Запускаем загрузку переменных сообщений параллельно с остальными запросами
            const messageVarsPromise = Promise.all([
                getClientList({ projectId: this.project.id }).then(d => d.data!),
                api.gcb2
                    .getMessageVarsValues({
                        projectId: this.project.id,
                        varIds: MESSAGE_VARS.map(el => el.id),
                    })
                    .then(res => res.data!.map(el => ({ ...el, _id: uuidv4() }))),
            ])
            // audienceList → fetchLists → initAudienceFilterValues должны идти последовательно
            this.audienceList = await getAudience(this.project.id, this.isHrProject)
            await this.fetchLists()
            this.initAudienceFilterValues()
            // Дожидаемся результатов загрузки переменных
            const [_messageVarClientList, _messageVarExceptions] = await messageVarsPromise
            this.messageVarClientList = _messageVarClientList.concat({ id: '_DEFAULT_MESSAGE_VAR', name: 'По умолчанию' })
            this.messageVarExceptions = _messageVarExceptions
            
            // Отдельная ветка для isChannelsRework
            if (this.project.isChannelsRework) {
                try {
                    const projectId = this.project?.projectId || this.project?.id || this.$router.currentRoute.params.id
                    const { data: projectCascades, error } = await getCascadesByProject(projectId)
                    this.cascadesForBotSettings = !error && Array.isArray(projectCascades) ? projectCascades : []
                } catch {
                    this.cascadesForBotSettings = []
                }
                // Получаем список каналов
                const channelTypes = Object.values(CHANNEL_TYPES)
                const channels = this.project.connectors.filter(c => 
                    !c.isChisai && 
                    c.connectorType !== CONNECTOR_TYPES.whatsappBasis &&
                    channelTypes.includes(c.connectorType)
                )
                
                // Группы каналов для нумерации
                const channelGroups = [
                    {
                        name: 'whatsapp',
                        channelTypes: [CHANNEL_TYPES.whatsappChannel],
                    },
                    {
                        name: 'telegram',
                        channelTypes: [CHANNEL_TYPES.telegramChannel],
                    },
                    {
                        name: 'max',
                        channelTypes: [CHANNEL_TYPES.maxChannel],
                    },
                ]
                
                // Функция для получения индекса канала в группе
                const getChannelIndex = (connectorType: string, connectorId: string) => {
                    const group = channelGroups.find(g => g.channelTypes.includes(connectorType))
                    if (!group) return 1
                    
                    const channelsInGroup = channels
                        .filter(c => {
                            if (!c.isChisai && c.connectorType === connectorType) {
                                return true
                            }
                            return false
                        })
                        .sort((a, b) => {
                            const aTime = a.createdAt && a.createdAt > 0 ? a.createdAt : Number.MAX_SAFE_INTEGER
                            const bTime = b.createdAt && b.createdAt > 0 ? b.createdAt : Number.MAX_SAFE_INTEGER
                            if (aTime !== Number.MAX_SAFE_INTEGER && bTime !== Number.MAX_SAFE_INTEGER) {
                                return aTime - bTime
                            }
                            if (aTime === Number.MAX_SAFE_INTEGER && bTime !== Number.MAX_SAFE_INTEGER) {
                                return 1
                            }
                            if (aTime !== Number.MAX_SAFE_INTEGER && bTime === Number.MAX_SAFE_INTEGER) {
                                return -1
                            }
                            return a.connectorId.localeCompare(b.connectorId)
                        })
                    
                    const currentIndex = channelsInGroup.findIndex(c => c.connectorId === connectorId)
                    return currentIndex >= 0 ? currentIndex + 1 : 1
                }
                
                // Функция для получения отображаемого имени канала
                const getChannelDisplayName = (connectorType: string, index: number) => {
                    const baseNames = {
                        [CHANNEL_TYPES.whatsappChannel]: 'WhatsApp',
                        [CHANNEL_TYPES.telegramChannel]: 'Telegram',
                        [CHANNEL_TYPES.maxChannel]: 'MAX',
                    }
                    const baseName = baseNames[connectorType] || connectorType
                    
                    if (index === 1) {
                        return baseName
                    }
                    return `${baseName} ${index}`
                }
                
                // Формируем список каналов
                channels.forEach(connector => {
                    const connectorType = connector.connectorType
                    const index = getChannelIndex(connectorType, connector.connectorId)
                    const displayName = getChannelDisplayName(connectorType, index)
                    const channelId = connector.channelId || connector.connectorId
                    
                    this.availableBots.push({
                        id: channelId,
                        name: displayName,
                    })
                })
            } else {
                // Старая логика для случая без isChannelsRework
                const filteredConnectors = this.project.connectors.filter(el =>
                    {   let connectorTypes = [...MESSAGING_CONNECTOR_TYPES]
                        if (cfg.botYcAvailable.includes(this.project.id)) {
                            connectorTypes.push(CONNECTOR_TYPES.yClients)
                        }
                        return connectorTypes.includes(el.connectorType)
                    }
                )
                for (const item of filteredConnectors) {
                    let name = ''
                    const isSpareConnector = item?.connectorId?.includes('spare')
                    if (item.connectorType === CONNECTOR_TYPES.whatsappBasis) {
                        const [app, error] = await api.networkFixer
                            .getApp({ connectorId: item.connectorId })
                            .then(res => [res.data!.data, res.error])
                        if (app?.channel?.['wApi-telegram']?.credentials || app?.channel?.['dh-telegram']?.credentials) {
                            name = 'Telegram'
                        } else if (app?.channel?.['green-api-max']?.credentials) {
                            name = 'MAX'
                        } else {
                            name = 'Whatsapp'
                        }
                    } else {
                        name =
                            this.connectorsHashMapWithKeysByConnectorsType[item.connectorType].name ??
                            item.connectorType
                    }
                    this.availableBots.push({
                        id: item.connectorId,
                        name: isSpareConnector ? `${name} (запасной)` : name,
                    })
                }
            }
            this.priorityInitial = this.activations.reduce((acc, el) => {
                acc[el.id] = el.priority
                return acc
            }, {})
            this.priorityOld = cloneDeep(this.priorityInitial)
            } catch {
                // loading всегда сбрасывается в finally
            } finally {
                this.loading = false
                this.saveInParent()
            }
        },
        isEmpty(value) {
            return isEmpty(value)
        },
        normalizeEnabledPriorities() {
            const enabled = this.activations
                .filter(a => a.isRunning)
                .sort((a, b) => a.priority - b.priority);
            enabled.forEach((a, idx) => {
                this.$set(a, 'priority', idx + 1);
            });
            this.priorityOld = cloneDeep(this.currentPriority)
        },
        onToggleActivation(activation) {
            if (activation.isRunning) {
                if(this.status === 'inactive' && this.activationAvailable) {
                    this.$emit('setActivationAvailable', 'minus')
                }
                const enabled = this.activations.filter(a => a.isRunning && a.id !== activation.id);
                activation.priority = enabled.length + 1;
            } else {
                if(this.status === 'inactive') {
                    this.$emit('setActivationAvailable', 'plus')
                }
                activation.priority = null
            }
            this.normalizeEnabledPriorities();
            this.$nextTick(() => {
                if (!this.disableCardVirtualization) {
                    this.updateVirtualizationAfterSort()
                }
            })
        },
    },

    async created() {
        await this.initData()
    },
    mounted() {
        this.lastScrollY = window.scrollY || window.pageYOffset || 0
        this.visibleActivationIds = this.filteredActivations.slice(0, 5).map((activation) => activation.id)
        this.$nextTick(() => {
            this.refreshVisibleRowHeights()
            if (this.filteredActivations.length) {
                this.setVisibleAroundActivations([this.filteredActivations[0].id], 'down')
            }
            this.syncVisibleActivationsByViewport()
        })
        window.addEventListener('scroll', this.syncVisibleActivationsByViewport as EventListener, { passive: true })
        window.addEventListener('keydown', this.onBrowserFindKeydown as EventListener, { passive: true })
        document.addEventListener('selectionchange', this.captureBrowserFindText as EventListener, { passive: true })
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.syncVisibleActivationsByViewport as EventListener)
        window.removeEventListener('keydown', this.onBrowserFindKeydown as EventListener)
        document.removeEventListener('selectionchange', this.captureBrowserFindText as EventListener)
    },
    updated() {
        if (this.activations.length < 100) return
        this.refreshVisibleRowHeights()
    },
})
